var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "print_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M16 16C16.5128 16 16.9355 16.386 16.9933 16.8834L17 17V21C17 21.5128 16.614 21.9355 16.1166 21.9933L16 22H8C7.48717 22 7.06449 21.614 7.00673 21.1166L7 21V17C7 16.4872 7.38604 16.0645 7.88338 16.0067L8 16H16ZM19 7C20.6569 7 22 8.34315 22 10V17C22 18.1046 21.1046 19 20 19H19V16C19 14.8954 18.1046 14 17 14H7C5.89543 14 5 14.8954 5 16V19H4C2.89543 19 2 18.1046 2 17V10C2 8.34315 3.34315 7 5 7H19ZM17 9H15C14.4477 9 14 9.44772 14 10C14 10.5128 14.386 10.9355 14.8834 10.9933L15 11H17C17.5523 11 18 10.5523 18 10C18 9.48717 17.614 9.06449 17.1166 9.00673L17 9ZM17 2C17.5523 2 18 2.44772 18 3V5H6V3C6 2.44772 6.44772 2 7 2H17Z",
    fill: "#15803D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.de37dc93b35ee2172f3bf97bb5a8df73.svg";
export { ForwardRef as ReactComponent };